import { PageAction } from '@progress/kendo-angular-grid/dist/es2015/scrolling/scroller.service';
import { AgentGreetingRemoteDto as AgentGreeting } from 'src/generated/signalR/agent-greeting-remote-dto';
import { AgentGreetingWaveRemoteDto as AgentGreetingWave } from 'src/generated/signalR/agent-greeting-wave-remote-dto';
import { AgentGreetingItem, AgentGreetingSettings, AudioFileInfo } from './agent-greeting-settings.state';

export class UpdateAgentGreetingItems {
   public static readonly type = '[AgentGreetings] Update Agent Greeting Items';

   constructor(public items: AgentGreetingItem[]) {}
}

export class UpdateGreetingWaves {
   public static readonly type = '[AgentGreetings] Update Greeting Waves';

   constructor(public waves: AgentGreetingWave[]) {}
}

export class UpdateAgentGreetingsFromServer {
   public static readonly type = '[AgentGreetings] Update Agent Greetings';

   constructor(public agentGreetings: AgentGreeting[]) {}
}
export class UpdateAgentGreetingWavesFromServer {
   public static readonly type = '[AgentGreetings] Update Agent Greeting Waves';

   constructor(public agentGreetingWaves: AgentGreetingWave[]) {}
}

export class PersistAgentGreetings {
   public static readonly type = '[AgentGreetings] Persist Agent Greetings';

   constructor() {}
}

export class AddGreetingWave {
   public static readonly type = '[AgentGreetings] Add Greeting Wave';

   constructor(public wave: AgentGreetingWave) {}
}

export class RemoveGreetingWave {
   public static readonly type = '[AgentGreetings] Remove Greeting Wave';

   constructor(public wave: AudioFileInfo) {}
}

export class AddGreetingItem {
   public static readonly type = '[AgentGreetings] Add Greeting Item';

   constructor(public item: AgentGreetingItem) {}
}

export class AddGreetingItems {
   public static readonly type = '[AgentGreetings] Add Greeting Items';

   constructor(public items: AgentGreetingItem[]) {}
}

export class RemoveGreetingItem {
   public static readonly type = '[AgentGreetings] Remove Greeting Item';

   constructor(public item: AgentGreetingItem) {}
}

export class RemoveGreetingItems {
   public static readonly type = '[AgentGreetings] Remove Greeting Items';

   constructor(public items: AgentGreetingItem[]) {}
}

export class SetAgentGreetingSkillFilter {
   public static readonly type = '[AgentGreetings] Set Agent Greeting Skill Filter';

   constructor(public filter: string) {}
}

export class SetAgentGreetingPage {
   public static readonly type = '[AgentGreetings] Set Agent Greeting Page';

   constructor(public currentPage: PageAction) {}
}

export class SetAgentGreetingDraggedItemKey {
   public static readonly type = '[AgentGreetings] Set Agent Greeting Dragged Item Key';

   constructor(public draggedItemKey: AudioFileInfo) {}
}

export class SetAgentGreetingIsIciDisplayGrouped {
   public static readonly type = '[AgentGreetings] Set Agent Greeting Is Ici Display Grouped';

   constructor(public isIciDisplayGrouped: boolean) {}
}

export class SetAgentGreetingsIsInEditing {
   public static readonly type = '[AgentGreetings] Set Agent Greetings Is In Editing';

   constructor(public isEditable: boolean) {}
}

export class SetWasValuePersisted {
   public static readonly type = '[AgentGreetings] Set Was Value Persisted';

   constructor(public wasValuePersisted: boolean) {}
}

export class SetAgentGreetingsDraftSettings {
   public static readonly type = '[AgentGreetings] Set Agent Greetings Draft Settings';

   constructor(public settings: AgentGreetingSettings) {}
}

export class SetAgentGreetingsSettings {
   public static readonly type = '[AgentGreetings] Set Agent Greetings Settings';

   constructor(public settings: AgentGreetingSettings) {}
}
